module.exports = "/_next/static/images/clothing-items-172da66dc22ed42f2d0218b8af4548ad.png";